module.exports = __webpack_public_path__ + "img/ic-mastercard.9d68eaf8.svg";